<template>
	<div v-if="show">
		<dc-icon
			class="has-text-danger"
			icon="superpowers"
			library="fab"
			size="2x"
		/>
	</div>
</template>

<script>
export default {
	props: {
		type: {
			type: String,
			default: () => "super"
		}
	},
	computed: {
		show() {
			return this.type === "super";
		}
	}
};
</script>
